const getAdmin = async () => (await import("@/api/admin.api")).default;

export const requests = {
  key: "terms-and-privacy",
  acceptTermsOfService: async () => {
    const admin = await getAdmin();
    const response = await admin.acceptTermsOfService();
    return response;
  },
  acceptPrivacyPolicy: async () => {
    const admin = await getAdmin();
    const response = await admin.acceptPrivacyPolicy();
    return response;
  },
  resetTermsOfService: async () => {
    const admin = await getAdmin();
    const response = await admin.resetTermsOfService();
    return response;
  },
  resetPrivacyPolicy: async () => {
    const admin = await getAdmin();
    const response = await admin.resetPrivacyPolicy();
    return response;
  },
};
